export default __webpack_public_path__ + "static/media/fassaden2.1edcc8da.jpg";